module.exports = __webpack_public_path__ + "static/img/4.331d264.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/benjyfishy/4.png
// module id = nTPN
// module chunks = 35